// Shared motion vocabulary (after Lusion/Stripe): expo-out reveals, in-out curtains, quick UI.
export const EASE_OUT = [0.16, 1, 0.3, 1];
export const EASE_QUART = [0.25, 1, 0.5, 1];
export const EASE_IN_OUT = [0.65, 0, 0.35, 1]; // pinned sections and page transitions
export const EASE_UI = [0.4, 0, 0.1, 1]; // hovers, menus

// Stagger rhythm from Textura's motion rules: lines 100ms over 900ms, words 60ms over 700ms
export const LINE_STAGGER = 0.1;
export const WORD_STAGGER = 0.06;
export const REVEAL_DURATION = 0.9;

// whileInView defaults: animate once, when a fifth of the element is visible
export const VIEWPORT = { once: true, amount: 0.2 };

// Parse a figure like "45%", "$2M", "3x", "50,000+" into { prefix, number, decimals, suffix }
export const parseFigure = value => {
  const match = String(value).match(/^([^0-9]*)([0-9][0-9,]*\.?[0-9]*)(.*)$/);
  if (!match) return null;
  const [, prefix, raw, suffix] = match;
  const number = parseFloat(raw.replace(/,/g, ''));
  const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;
  return { prefix, number, decimals, suffix, grouped: raw.includes(',') };
};
